export class FakeOverlayTemplate {
  private readonly root: HTMLDivElement;

  constructor() {
    this.root = this.createMainDiv();
    document.body.appendChild(this.root);
  }

  private createMainDiv(): HTMLDivElement {
    const div = document.createElement('div');
    Object.assign(div.style, {
      zIndex: 999999999999,
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      fontSize: '2em',
      display: 'flex',
      fontFamily: 'Verdana',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      backgroundColor: 'rgba(0,0,0,0.5)',
    });

    return div;
  }

  public addButton(label: string, callback: () => void): this {
    const btn = document.createElement('button');
    Object.assign(btn.style, { fontSize: '1.5em', display: 'block', margin: '1em', borderRadius: '0.2em' });
    btn.innerText = label;
    btn.addEventListener('click', () => {
      callback();
    });
    this.root.appendChild(btn);
    return this;
  }

  public addImage(image: string): this {
    const imageElement = new Image();
    imageElement.src = image;
    this.root.appendChild(imageElement);
    return this;
  }

  public addText(text: string, fontSize = '1em'): this {
    const textContainer = document.createElement('div');
    Object.assign(textContainer.style, { fontSize });
    textContainer.innerText = text;
    this.root.appendChild(textContainer);
    return this;
  }

  public addObject(object: object): this {
    return this.addText(JSON.stringify(object, null, ' '), '0.5em');
  }

  public destroy(): void {
    document.body.removeChild(this.root);
  }
}
